define('views/modules/calendar/calendar/calendar-component/modal/calendar-session-print-modal',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'html2pdf',
    'moment',
    // services
    'services/user',
    'services/i18n',
    // models
    'models/calendar/session',
    // collection
    'collections/member/supervisors',
    // views
    'views/parts/modal/modal',
    'views/modules/calendar/animated-session/exercise/lists/print/print-exercise-list',
    // templates
    'text!templates/modules/calendar/calendar/calendar-component/modal/calendar-session-print-modal.html',

], function(
    // Libs
    _, Backbone, Mustache, U, html2pdf, moment,
    // services
    User,
    i18n,
    // models
    MSession,
    // collection
    Supervisors,
    // views
    VModal,
    VWeekExerciseList,
    //templates
    TCalendarSessionPrintModal
) {
    var VCalendarSessionPrintModal = VModal.extend({
        template: TCalendarSessionPrintModal,
        exerciseListView: VWeekExerciseList,

        regions: {
            list: '.exercise-list',
        },

        modal: function() {
            var buttons = {
                ok: {
                    label: " ",
                    className: 'sl-icon-printer btn-print',
                    callback: this.onPrint
                },
            };

            return {
                closeButton: true,
                title: i18n.t("Print"),
                size: 'large',
                buttons: buttons
            };
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);
        },

        render: function() {
            var view = this.view;
            var html = Mustache.render(this.template, Mustache.getContext({
                description: this.session.getNotes().split(/[\r\n]+/).map(function(line) { return { descLine: line }; }),
                sessionDay: this.getSessionDay(),
                logoUrl: User.get('logoUrl'),
                coachGroupName: User.getMainGroup().name
            }));
            this.$el.empty().append(html);

            this.generateZones()
                .assign(view.list, this.zone.$list);

            this.renderModal();

            return this;
        },

        show: function(model) {
            this.render();
        },

        setModel: function(model) {
            this.model = model;
            return this;
        },

        setSession: function(session) {
            this.session = session;
            this.collection = session.getExerciseCollection();
            this.showExercisesList()
            return this;
        },

        fetchRelatedSession: function() {
            var model = this.model,
                session = new MSession();

            session.setId(model.get('session'))
                .fetch({
                    context: this,
                    success: this.onSessionSync
                });
        },

        showExercisesList: function() {
            var model = this.model,
                collection = this.collection;

            this.view = {
                list: new this.exerciseListView({
                    model: this.session,
                    role: 'supervisor',
                    collection: collection,
                    item: model,
                    summary: true,
                    sortable: false
                }),
            };

            this.render();
        },

        getSessionDay: function() {
            if (this.model.get('session').startsWith('@')) {
                return moment().day(this.model.get('dayId') + 1).format('dddd')
            }

            return this.model.getDate().format('dddd');
        },

        ////////////
        // events //
        ////////////
        onPrint: function(confirmed) {
            var filename = "TotalCoaching-Session-" + moment().unix() + ".pdf";
            html2pdf(this.$modal.find(".modal-body")[0], {
              margin: 0.25,
              filename: filename,
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { dpi: 192, letterRendering: true, foreignObjectRendering: true, useCORS: true },
              jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait', pagesplit: true, useFor: 'page' }
            });
        },

        onSessionSync: function(model, options) {
            this.session = model;
            this.collection = model.getExerciseCollection();
            this.showExercisesList();
        },

    });

    return VCalendarSessionPrintModal;
});

